<template>
    <div class="wrapper">
        <page-header/>
        <div class="section">
            <div class="container">
                <div class="row">
                    <div class="col-md-5">
                        <img class="d-block img-raised" :src="productDetail.cover_image.path"/>
                    </div>
                    <div class="col-md-6 ml-auto mr-auto">
                        <h4 class="title">{{ productDetail.name }}</h4>
                        <p class="category">品牌類別：任天堂</p>
                        <p class="category" style="white-space: pre-line;">商品內容：{{ productDetail.summary }}</p>

                        <div class="price">月付 <strong>NT$ {{ plan.period_amount }}</strong> * {{ plan.period_count }}期</div>

                        <div class="price">總金額 <strong>NT$ {{ plan.period_amount * plan.period_count }}</strong></div>
                    </div>
                </div>
                <hr class="my-5">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <form @submit.prevent="submit">
                            <fg-input class="input-lg"
                                      placeholder="收件人姓名"
                                      autocomplete="off"
                                      v-model="form.name"
                            />

                            <fg-input class="input-lg"
                                      placeholder="收件人電話"
                                      autocomplete="off"
                                      v-model="form.phone_number"
                            />

                            <fg-input class="input-lg"
                                      placeholder="郵遞區號"
                                      autocomplete="off"
                                      v-model="form.postal_code"
                            />

                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <div class="input-group mt-1 mb-3">
                                        <select class="custom-select" v-model="countyIndex" @change="changeCounty">
                                            <option v-for="option in countiesOptions" :value="option.value">{{
                                                option.label }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 col-12">
                                    <div class="input-group mt-1 mb-3">
                                        <select class="custom-select" v-model="areaIndex">
                                            <option v-for="option in areaOptions[countyIndex || 0]"
                                                    :value="option.value">{{ option.label }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <fg-input class="input-lg"
                                      placeholder="收件人地址"
                                      autocomplete="off"
                                      v-model="form.address"
                            />

                            <button type="submit" class="btn btn-outline-info btn-round" :disabled="isLoading">確認訂單</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {PRODUCT_DETAIL_QUERY} from "@/services/graphql/product";
    import {countiesOptions, areaOptions} from '@/constants/address';
    import {Card, Button, FormGroupInput} from '@/components';
    import {alertSuccess, alertError} from '@/helper/alert_helper';
    import {OrderService} from "@/services/rest/order";
    import PageHeader from "../partials/PageHeader";

    export default {
        name: "OrderConfirm",
        components: {
            PageHeader,
            Card,
            [Button.name]: Button,
            [FormGroupInput.name]: FormGroupInput
        },
        data() {
            return {
                isLoading: false,
                countiesOptions,
                areaOptions,
                plan: {},
                countyIndex: 0,
                areaIndex: 0,
                form: {
                    name: '',
                    phone_number: '',
                    postal_code: '',
                    address: '',
                },
                productDetail: {
                    cover_image: {},
                    plans: []
                },
            }
        },
        methods: {
            async getData() {
                try {
                    const product_id = parseInt(this.$route.query.product_id);

                    if(!product_id) {
                        this.$router.push({name: 'Home'});
                        return;
                    }

                    const q = await this.$apollo.query({
                        query: PRODUCT_DETAIL_QUERY,
                        variables: {
                            product_id
                        },
                        fetchPolicy: "network-only"
                    });

                    const productDetail = q.data.productDetail;

                    if(!productDetail) {
                        this.$router.push({name: 'Home'});
                        return;
                    }

                    this.productDetail = productDetail;

                    const periodCount = parseInt(this.$route.query.period_count);

                    const foundPlan = productDetail.plans.find((plan) => {
                        return plan.period_count === periodCount;
                    });

                    if(!foundPlan) {
                        this.$router.push({name: 'Home'});
                        return;
                    }

                    this.plan = foundPlan;
                } catch (err) {
                    console.error(err);
                }
            },
            changeCounty() {
                this.areaIndex = 0;
            },
            async submit() {
                try {
                    this.isLoading = true;

                    const {data} = await new OrderService().send(this.productDetail.product_id, this.plan.period_count, {
                        ...this.form,
                        county: this.countiesOptions[this.countyIndex].label,
                        area: this.areaOptions[this.countyIndex][this.areaIndex].label,
                    });

                    alertSuccess({
                        text: '下單成功',
                    })

                    this.$router.push({name: 'OrderFinish', query: {payment_url: data.payment_url}});
                } catch (err) {
                    alertError(err);
                } finally {
                    this.isLoading = false;
                }
            }
        },
        created() {
            this.getData();
        }
    }
</script>

<style scoped lang="scss">
    .custom-select {
        border-radius: 30px;
        font-size: 12px;
    }
</style>